/**
 * @generated SignedSource<<63d89571de760056e7ee8e9846267dab>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime'
import { FragmentRefs } from 'relay-runtime'
export type PostSeoHead_post$data = {
  readonly h1: string
  readonly slug: string
  readonly image: {
    readonly url: string
  } | null
  readonly meta_description: string | null
  readonly meta_keywords: string | null
  readonly meta_robots: string | null
  readonly ' $fragmentType': 'PostSeoHead_post'
}
export type PostSeoHead_post$key = {
  readonly ' $data'?: PostSeoHead_post$data
  readonly ' $fragmentSpreads': FragmentRefs<'PostSeoHead_post'>
}

const node: ReaderFragment = {
  argumentDefinitions: [],
  kind: 'Fragment',
  metadata: null,
  name: 'PostSeoHead_post',
  selections: [
    {
      alias: null,
      args: null,
      kind: 'ScalarField',
      name: 'h1',
      storageKey: null
    },
    {
      alias: null,
      args: null,
      kind: 'ScalarField',
      name: 'slug',
      storageKey: null
    },
    {
      alias: null,
      args: null,
      concreteType: 'PostImage',
      kind: 'LinkedField',
      name: 'image',
      plural: false,
      selections: [
        {
          alias: null,
          args: null,
          kind: 'ScalarField',
          name: 'url',
          storageKey: null
        }
      ],
      storageKey: null
    },
    {
      alias: null,
      args: null,
      kind: 'ScalarField',
      name: 'meta_description',
      storageKey: null
    },
    {
      alias: null,
      args: null,
      kind: 'ScalarField',
      name: 'meta_keywords',
      storageKey: null
    },
    {
      alias: null,
      args: null,
      kind: 'ScalarField',
      name: 'meta_robots',
      storageKey: null
    }
  ],
  type: 'Post',
  abstractKey: null
}

;(node as any).hash = 'e12347d144a4de4982ccc69653a548fa'

export default node
